// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"6d0706bf","54":"7bc0fdbc","140":"d55a39dd","314":"b47d4b91","432":"e0777cb1","564":"7a816c93","871":"6e0f9bad"}[chunkId] + ".chunk.js";
};